import { type ScopedPermissions } from '@air/api';
import { type WorkspaceUserRole } from '@air/api/types';

export const isPermissionsGTE = (high: ScopedPermissions, low: ScopedPermissions) =>
  Object.entries(low).every(([scope, properties]) =>
    // https://linear.app/air/issue/ENG-126/update-high-in-ispermissionsgte-to-not-use-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(properties).every(([property, required]) => !required || (high as any)?.[scope]?.[property]),
  );

export const getLeastPermissiveRole = (roles: WorkspaceUserRole[]): WorkspaceUserRole =>
  roles.reduce(
    (selectedRole, role) => (isPermissionsGTE(selectedRole.permissions, role.permissions) ? role : selectedRole),
    roles[0],
  );
